export default __webpack_public_path__ + "static/media/loading.6c41f189.svg";